import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import 'common/stylus/index.styl'
import Dater from 'common/util/dateUtil.js'
import fastclick from 'fastclick'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueResource from 'vue-resource'

/**
 * 这个body下的点击没有300ms延迟
 */
fastclick.attach(document.body)
Vue.prototype.$ajax = axios
Vue.use(ElementUI)
Vue.use(Dater)
Vue.use(VueResource)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js